export const systemFr = {
  // LegalPage
  'system.legal.fallbackTitle': 'Document',
  'system.legal.fallbackBody': 'Non trouvé.',
  'system.legal.lastUpdated': 'Dernière mise à jour {date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'Perdu dans le Voile',
  'system.notFound.heading': 'Tu t\'es aventuré au-delà des limites de la carte',
  'system.notFound.body': 'Le chemin que tu recherchais a été englouti par le crépuscule éternel.',
  'system.notFound.returnCta': 'Revenir au Voile',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Une perturbation inconnue a secoué le voile.',
  'system.error.seoTitle': 'Une Perturbation dans le Voile',
  'system.error.heading': 'Le rituel a failli',
  'system.error.body':
    'Quelque chose d\'invisible a perturbé cette page. Le voile est mince ici — réessaye, ou retourne vers un endroit plus sûr.',
  'system.error.tryAgain': 'Réessayer',
  'system.error.returnCta': 'Revenir au Voile',
  'licenseGate.heading': "Bientôt disponible — accès restreint par licence",
  'licenseGate.body': "Cette édition linguistique n'est pas encore disponible pour des raisons de licence. Elle arrive — reviens bientôt.",
} as const
